import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import { connect } from 'react-redux';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PushNotificationsForm from './PushNotificationsForm';
import BlitzAPI from '../../api/BlitzAPI';

function trStyleFormat(row) {
  let outClass;
  switch (row.type) {
    case 'feed':
      outClass = 'entry-table-feed';
      break;
    case 'youtube':
      outClass = 'entry-table-video';
      break;
    default:
      outClass = 'entry-table-default';
  }
  return outClass;
}

class PushNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      initialValues: null,
    };
    this.onRowClick = this.onRowClick.bind(this);
    this.sendPushNotification = this.sendPushNotification.bind(this);
  }

  componentDidMount() {
    BlitzAPI.getEntries({ published: true, type: 'feed,youtube,article' }).then(
      (resp) => {
        return this.setState({ data: resp.data.data });
      },
    );
  }

  onRowClick(row) {
    const { changeFormValue } = this.props;
    changeFormValue('message', row.title);
    changeFormValue('entry', row);
  }

  sendPushNotification(values) {
    if (confirm('About to send a push notification')) {
      BlitzAPI.sendPushNotification({ notification: values }).then(
        response => console.log(response),
      );
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col-sm-4">
          <PushNotificationsForm onSubmit={this.sendPushNotification} />
        </div>
        <div className="col-sm-8">
          {this.state.data ?
            <BootstrapTable
              data={this.state.data}
              remote striped hover
              trClassName={trStyleFormat}
              options={{ onRowClick: this.onRowClick }}
            >
              <TableHeaderColumn isKey dataField="id" width="70">Entry ID</TableHeaderColumn>
              <TableHeaderColumn dataField="title">Title</TableHeaderColumn>
            </BootstrapTable> : null
          }
        </div>
      </div>
    );
  }
}

PushNotifications.propTypes = {
  changeFormValue: PropTypes.func,
};

function mapStateToProps(state) { return {}; }
function mapDispatchToProps(dispatch) {
  return {
    changeFormValue: (field, value) => {
      dispatch(change('push_notifications', field, value));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PushNotifications);



// WEBPACK FOOTER //
// ./src/cms/notifications/PushNotifications.js